import {AdminUserType} from './Messaging/AdminUserType';
import {ManagerUserType} from './Messaging/ManagerUserType';
import {MessageSenderUserType} from './Messaging/MessageSenderUserType';
import {MessageAnalystUserType} from './Messaging/MessageAnalystUserType';

export enum MessagingRole {
  Undetermined,
  Admin,
  Manager,
  MessageSender,
  MessageAnalyst,
}

export class UndeterminedMessagingUserType {
  public readonly key = 'UndeterminedMessagingUserType';
  public readonly messagingRole = MessagingRole.Undetermined;
}

export class InvalidMessagingUserType {
  public readonly key = 'InvalidMessagingUserType';
  public readonly value = new UndeterminedMessagingUserType();
}

export class ValidMessagingUserType {
  public readonly key = 'ValidMessagingUserType';

  constructor(
    public readonly value: AdminUserType | ManagerUserType | MessageSenderUserType | MessageAnalystUserType
  ) {}
}

export type MessagingUserType = ValidMessagingUserType | InvalidMessagingUserType | UndeterminedMessagingUserType;

type MessagingUserTypeOptions<TReturn> = {
  Admin: (adminUserType: AdminUserType) => TReturn;
  Manager: (managerUserType: ManagerUserType) => TReturn;
  MessageSender: (messageSenderUserType: MessageSenderUserType) => TReturn;
  MessageAnalyst: (messageAnalystUserType: MessageAnalystUserType) => TReturn;
  Undetermined: () => TReturn;
};

export const matchMessagingUserType = <TReturn>(
  messagingUserType: ValidMessagingUserType['value'] | InvalidMessagingUserType['value'],
  options: MessagingUserTypeOptions<TReturn>
): TReturn => {
  switch (messagingUserType.key) {
    case 'UndeterminedMessagingUserType':
      return options.Undetermined();
    case 'AdminUserType':
      return options.Admin(messagingUserType);
    case 'ManagerUserType':
      return options.Manager(messagingUserType);
    case 'MessageSenderUserType':
      return options.MessageSender(messagingUserType);
    case 'MessageAnalystUserType':
      return options.MessageAnalyst(messagingUserType);
  }
};
